export class LoginVM {
    constructor({username, password}) {
      this.username = username;
      this.password = password;
      this.grandtype = "password"
    }
  }